import React from "react";
import { AbsoluteCenter } from "../../layout/AbsoluteCenter/AbsoluteCenter";
import { PanelLayout } from "../../layout/Panel/Panel";
import { Spacing } from "../../layout/Spacing/Spacing";
import { TextCustom } from "../../ui/TextCustom";
import IconComponent from "../IconComponents/IconComponent";
import { FlexCenter } from "../../layout/FlexCenter/FlexCenter";
import { Title } from "../../ui/Title";
import { SpacingCustom } from "../../layout/Spacing/SpacingCustom";
import { ToolsWarning } from "../../features/LauncherConfiguration/Features/ToolsWarning";
import { ErrorNotification } from "../ErrorNotification/ErrorNotification";
import { ExecButton } from "../../ui/ExecButton/ExecButton";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/constants";

export const NotAllowed = () => {
    const navigate = useNavigate();
    return (
        <FlexCenter>
                <SpacingCustom paddingTop={10}>
                    <PanelLayout>
                        <Spacing paddingSpacing="xl" marginSpacing="none">
                            <FlexCenter direction="h" position="end" gap={2}>
                                <ErrorNotification error={"Access Denied"} text={"You do not have permission to access this page. Please log in to continue."} textSize={1.2}/>
                                <ExecButton label={"Go to projects"} iconName={"Back"} func={() => navigate(`/${ROUTES.PROJECTS}`)}/>
                            </FlexCenter>
                        </Spacing>
                    </PanelLayout>
                </SpacingCustom>
        </FlexCenter>
    )
}